import React from 'react'
import { AccountKYCForm } from '../shared/AccountKYCForm'

export const RegisterAccountKYC = () => {
  return <AccountKYCForm successPath="/register-account/success" createAccount={false} />
}
